import { render, staticRenderFns } from "./PushNotifications.vue?vue&type=template&id=13da918c&"
import script from "./PushNotifications.vue?vue&type=script&lang=js&"
export * from "./PushNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports